var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7221 1.21855C14.0149 0.925695 14.4897 0.925835 14.7827 1.21855C15.0756 1.51143 15.0755 1.98619 14.7827 2.2791L2.2807 14.783C1.98782 15.0758 1.51304 15.0759 1.22015 14.783C0.927246 14.4901 0.927286 14.0154 1.22015 13.7225L13.7221 1.21855ZM12.6811 7.47051C12.974 7.17784 13.4488 7.17777 13.7416 7.47051C14.0342 7.76333 14.0342 8.23821 13.7416 8.53105L7.49066 14.783C7.19787 15.0758 6.72303 15.0756 6.43012 14.783C6.13722 14.4901 6.13724 14.0154 6.43012 13.7225L12.6811 7.47051Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizer);
export default __webpack_public_path__ + "static/media/resizer.b22ab347c0c29a9a2158b4c5d7d317f6.svg";
export { ForwardRef as ReactComponent };